<template>
  <section class="main-content">
    <MainBanner :banner="projectbannertitle" />
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Startseite - ito consult GmbH",
        "item": "https://ito-consult.de"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Projekte",
        "item": "https://ito-consult.de/projekte"
      },{
        "@type": "ListItem",
        "position": 3,
        "name": "{{project.title}}",
        "item": "https://ito-consult.de/projekte/{{project.slug}}"
      }]
    }
  </script>
    <section class="block-content mt-5">
      <div class="container pt-5">
        <div class="text-center" data-aos="fade-up" data-aos-duration="500">
            <h2 v-if="project">{{project.title}}</h2>
        </div>
      </div>
    </section>
    <section class="block-content mb-5">
        <div class="container py-md-5">
            <div v-if="project" id="timeline">
                <div v-for="(project,index) in project.content" :key="project.headline" class="row history-item my-md-5 py-md-5 align-items-center" data-aos="fade-up" data-aos-duration="500">
                    <div v-if="project.image" class="col-12 mb-3 mb-md-0 col-md-5" :class="{'order-md-2 offset-md-1' : index%2==0 }">
                        <div class="ratio ratio-16x9 img-container">
                          <img :src="getImageFromDirectusByID(project.image)" :title="project.headline" />
                        </div>
                    </div>
                    <div class="col-12 mb-3 mb-md-0 text" :class="{'text-md-end' : (index%2==0 && project.image) , 'offset-md-1' : index%2 && project.image, 'col-md-6' : project.image}">
                        <h3>{{project.headline}}</h3>
                        <article v-if="project.html" class="d-content" v-html="project.html"></article>
                        <article v-else class="d-content" v-html="project.description"></article>
                    </div>
                </div>
            </div>
            <a :href="project.link" v-if="project.link" target="_blank" class="btn btn-outline-ito hover-red animated-arrow mt-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                </svg>Projekt besuchen</a>
        </div>
    </section>
  </section>
</template>

<script>

import axios from 'axios'
import store from '@/store'
import router from '@/router'
const MainBanner = () => import('@/components/Content/MainBanner.vue')

export default {
  name: 'ProjectSingle',
  data: function () {
    return {
      project: {},
      temp_img: null
    }
  },
  computed: {
    project_id: function () {
      return this.$route.params.id
    },
    projectbannertitle: function () {
      return 'Projekte.' + this.project.title
    }
  },
  methods: {
    getImageFromDirectusByID (id) {
      axios.get('https://cdn.ito-consult.de/itoconsult//files/' + id)
        .then(response => (this.temp_img = response.data.data.data.full_url))

      return this.temp_img
    }
  },
  async beforeMount () {
    await axios.get('/projects?filter[slug]=' + this.project_id)
      .then(response => {
        if (response.data.data.length > 0) {
          this.project = response.data.data[0]
          store.commit('loadingStatus', false)
        } else {
          // Falls slug in directus nicht vorhanden, 404 Umleitung
          router.replace({ name: '404' })
        }
      })
  },
  components: {
    MainBanner
  }
}
</script>

<style>
  .feature {background: #eee; background: linear-gradient(#f6f6f6, #eee); height: 100%; font-size: .8em;}
</style>
